<template>
    <!-- 重点城市 -->
    <div>
        <!-- 头部-->
        <div class="child-head">
            <!-- 标题 -->
            <div class="child-head-left float-l">
                <img src="../../assets/area_title.png" class="head-img">
                <span>重点城市</span>
            </div>
        </div>
        <!-- 内容 -->
        <div class="content content-chunk-box">
            <!-- 边角 -->
            <contentCorner>
                <!-- 内容 -->
                <div class="content-div" v-if="!islickCityName">
                    <el-carousel height="500px" direction="vertical" indicator-position="none" :interval="30 * 1000"
                        :autoplay="autoplay" ref="carousel" @change="change">
                        <el-carousel-item v-for="(item, index) in cdata || []" :key="index">
                            <!-- 城市地图 -->
                            <div class="content-div-2">
                                <Chart :cdata="item || {}" />
                            </div>
                        </el-carousel-item>
                        <!-- 次数 -->
                        <div class="number">
                            <div class="number-div-1">
                                <div>累计运次</div>
                                <div class="number-div-2">
                                    <div v-show="isTodayQtyStr1">{{ todayQtyStr1 }}</div>
                                    <div v-show="isTodayQtyStr2">{{ todayQtyStr2 }}</div>
                                    <div v-show="isTodayQtyStr3">{{ todayQtyStr3 }}</div>
                                    <div v-show="isTodayQtyStr4">{{ todayQtyStr4 }}</div>
                                    <div v-show="isTodayQtyStr5">{{ todayQtyStr5 }}</div>
                                    <div v-show="isTodayQtyStr6">{{ todayQtyStr6 }}</div>
                                    <div v-show="isTodayQtyStr7">{{ todayQtyStr7 }}</div>
                                    <div v-show="isTodayQtyStr8">{{ todayQtyStr8 }}</div>
                                    <div v-show="isTodayQtyStr9">{{ todayQtyStr9 }}</div>
                                </div>
                            </div>
                            <div class="number-div-1" style=" margin-left: 25px;">
                                <div>今日运次</div>
                                <div class="number-div-2">
                                    <div v-show="isTodayQty1">{{ todayQty1 }}</div>
                                    <div v-show="isTodayQty2">{{ todayQty2 }}</div>
                                    <div v-show="isTodayQty3">{{ todayQty3 }}</div>
                                    <div v-show="isTodayQty4">{{ todayQty4 }}</div>
                                    <div v-show="isTodayQty5">{{ todayQty5 }}</div>
                                </div>
                            </div>
                        </div>
                    </el-carousel>
                </div>
                <!-- 选择 -->
                <div class="content-div" v-if="islickCityName">
                    <el-carousel height="500px" direction="vertical" :autoplay="true" indicator-position="none"
                        :interval="1000 * 60" ref="carousel" @change="change">
                        <el-carousel-item v-for="(item, index) in xdata" :key="index">
                            <!-- 城市地图 -->
                            <div class="content-div-2">
                                <Chart :cdata="item" />
                            </div>
                            <!-- 次数 -->
                            <div class="number">
                                <div class="number-div-1">
                                    <div>累计运次</div>
                                    <div class="number-div-2">
                                        <div v-show="isTodayQtyStr1">{{ todayQtyStr1 }}</div>
                                        <div v-show="isTodayQtyStr2">{{ todayQtyStr2 }}</div>
                                        <div v-show="isTodayQtyStr3">{{ todayQtyStr3 }}</div>
                                        <div v-show="isTodayQtyStr4">{{ todayQtyStr4 }}</div>
                                        <div v-show="isTodayQtyStr5">{{ todayQtyStr5 }}</div>
                                        <div v-show="isTodayQtyStr6">{{ todayQtyStr6 }}</div>
                                        <div v-show="isTodayQtyStr7">{{ todayQtyStr7 }}</div>
                                        <div v-show="isTodayQtyStr8">{{ todayQtyStr8 }}</div>
                                        <div v-show="isTodayQtyStr9">{{ todayQtyStr9 }}</div>
                                    </div>
                                </div>
                                <div class="number-div-1" style=" margin-left: 25px;">
                                    <div>今日运次</div>
                                    <div class="number-div-2" v-if="isTodayQty1">
                                        <div v-show="isTodayQty1">{{ todayQty1 }}</div>
                                        <div v-show="isTodayQty2">{{ todayQty2 }}</div>
                                        <div v-show="isTodayQty3">{{ todayQty3 }}</div>
                                        <div v-show="isTodayQty4">{{ todayQty4 }}</div>
                                        <div v-show="isTodayQty5">{{ todayQty5 }}</div>
                                    </div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </contentCorner>
        </div>
    </div>
</template>
<script>
import contentCorner from '../../components/common/contentCorner.vue';
import Chart from '../../components/cityMap/chart.vue';
import { cityTransportTotal, transferTimeLine, cityTransportBySubItem } from '../../api/holdMy'
export default {

    data() {
        return {
            todayQtyStr1: '-',
            isTodayQtyStr1: true,
            todayQtyStr2: '-',
            isTodayQtyStr2: true,
            todayQtyStr3: '-',
            isTodayQtyStr3: true,
            todayQtyStr4: '-',
            isTodayQtyStr4: true,
            todayQtyStr5: '-',
            isTodayQtyStr5: true,
            todayQtyStr6: '-',
            isTodayQtyStr6: true,
            todayQtyStr7: '-',
            isTodayQtyStr7: true,
            todayQtyStr8: '-',
            isTodayQtyStr8: true,
            todayQtyStr9: '-',
            isTodayQtyStr9: false,
            todayQty1: '-',
            isTodayQty1: true,
            todayQty2: '-',
            isTodayQty2: true,
            todayQty3: '-',
            isTodayQty3: true,
            todayQty4: '-',
            isTodayQty4: true,
            todayQty5: '-',
            isTodayQty5: false,
            cdata: [],
            cList: [],
            drawTiming: null,
            initialIndex: 0,
            localData: localStorage.getItem('clickCityName'),
            islickCityName: false,
            refreshtransportTotalg: null,
            autoplay: false, // 默认不开启轮播
            xdata: [],
            cityName: ''
        }
    },
    computed: {
        getLocalData() {
            return localStorage.getItem('clickCityName')
        },
    },
    components: { contentCorner, Chart },
    created() {
        let _this = this;
        //根据自己需要来监听对应的key
        window.addEventListener("setItemEvent", function (e) {
            //e.key : 是值发生变化的key
            //e.newValue : 是可以对应的新值
            if (e.key === "clickCityName") {
                _this.content = e.newValue;
                let data = JSON.parse(_this.content);
                _this.islickCityName = true;
                _this.getClickCity(data);
                setTimeout(() => {
                    _this.islickCityName = false;
                    _this.refreshtransportTotal();
                }, 60 * 1000)
            }
        })
    },
    watch: {
        //     // 监听城市数据列表
        '$store.state.cityTempData': function () {
            this.autoplay = false
            this.getTransportTodayByCity()
        }
    },
    mounted() { },

    beforeDestroy() {
        clearInterval(this.refreshtransportTotalg);
        this.refreshtransportTotalg = null
    },
    methods: {
        // 获取城市信息
        getTransportTodayByCity() {
            this.cList = [];
            let cityList = this.$store.state.cityTempData;
            cityList = cityList.filter(item => item.name.trim() !== '');
            // 根据 value 属性值从大到小进行排序
            // 排序只显示前六个
            cityList = cityList.sort((a, b) => b.value - a.value);
            this.cList = cityList.slice(0, 5);

            // 根据城市名称循环出轮播城市数据
            this.getCityTransportBySubItem(this.cList);
        },
        // 异步处理
        asyncFunction(item) {
            return new Promise((resolve) => {
                let data = {
                    autoIncId: 1,// id
                    city: item.name + "市"
                }
                // 获取根据城市名获取城市信息
                cityTransportBySubItem(data).then(res => {
                    if (res.result == 0) {
                        let data = res.userdata;
                        resolve({ name: item.name, value: item.value, list: data });
                    }
                }).catch(error => {
                    console.log(error);
                })
            });
        },
        async getCityTransportBySubItem(items) {
            const promises = [];
            for (const item of items) {
                const promise = this.asyncFunction(item);
                promises.push(promise);
            }
            const results = await Promise.all(promises);
            console.log(results, '所有操作已完成'); // 输出所有异步操作的结果数组
            // 在这里可以执行下一步逻辑
            this.cdata = results || []
            // 启动定时任务累计运次，今日运次
            this.refreshtransportTotal();
        },
        // 累计运次，今日运次刷新 60秒一次
        refreshtransportTotal() {
            // 初始化默认值为第一个城市
            this.cityName = this.cdata[0].name
            this.initialIndex = 0;
            this.getCiteTotal();
            clearInterval(this.refreshtransportTotalg);
            this.refreshtransportTotalg = setInterval(() => {
                this.getCiteTotal();
            }, 1000 * 60)
        },
        // 获取城市运次
        getCityTransportTotal() {
            return new Promise((resolve, reject) => {
                let data = {
                    type: 2,// id
                    city: this.cityName + '市'
                }
                cityTransportTotal(data).then(res => {
                    if (res.result == 0) {
                        resolve(res.userdata);
                    }
                }).catch(error => {
                    console.log(error);
                })
            });
        },
        // 获取今日运次
        getTransferTimeLine() {
            return new Promise((resolve, reject) => {
                let data = {
                    autoIncId: 1,// id
                    city: this.cityName + '市'
                }
                transferTimeLine(data).then(res => {
                    if (res.result == 0) {
                        resolve(res.userdata);
                    }
                }).catch(error => {
                    console.log(error);
                })
            });
        },
        // 初始化
        getCiteTotal() {
            this.autoplay = false;
            if (!this.cityName) return
            const promise1 = this.getCityTransportTotal();
            const promise2 = this.getTransferTimeLine();
            Promise.all([promise1, promise2])
                .then((results) => {
                    const result1 = results[0];
                    const result2 = results[1];
                    // 这里执行获取城市运次、获取今日运次两个接口请求全部完成后的下一步操作
                    this.csycData(result1);
                    this.jrcsycData(result2);
                    this.autoplay = true;
                    // 在这里进行接下来的逻辑处理或其他操作
                })
                .catch((error) => {
                    // 处理任何一个接口请求失败的情况
                    console.error('An error occurred:', error);
                });
        },
        // 地图轮播
        change(e) {
            this.cityName = this.cdata[e].name
            this.initialIndex = e;
            this.getCiteTotal();
        },
        // 点击全国地图时触发
        getClickCity(e) {
            // 结束定时任务
            this.autoplay = false
            clearInterval(this.refreshtransportTotalg);
            this.refreshtransportTotalg = null
            this.cityName = e.name
            let value = e.value + "";
            let list = [];
            let data = {
                autoIncId: 1,// id
                city: e.name + "市"
            }
            cityTransportBySubItem(data).then(res => {
                if (res.result == 0) {
                    let data = res.userdata;
                    list.push({ name: e.name, value: e.value, list: data });
                }
            }).catch(error => {
                console.log(error);
            })

            this.xdata = list;

            this.getCiteTotal();
            this.setData(value);
        },
        // 数据处理
        setData(value) {
            this.todayQty1 = value.substring(0, 1);
            this.isTodayQty1 = true;
            if (value.length > 1) {
                this.isTodayQty2 = true;
                this.todayQty2 = value.substring(1, 2)
            } else { this.isTodayQty2 = false; }
            if (value.length > 2) {
                this.isTodayQty3 = true;
                this.todayQty3 = value.substring(2, 3);
            } else { this.isTodayQty3 = false; }
            if (value.length > 3) {
                this.isTodayQty4 = true;
                this.todayQty4 = value.substring(3, 4);
            } else { this.isTodayQty4 = false; }
            if (value.length > 4) {
                this.isTodayQty5 = true;
                this.todayQty5 = value.substring(4, 5);
            } else { this.isTodayQty5 = false; }
        },
        // 获取城市运次数据处理
        csycData(data) {
            var todayQtyStr = data + '';
            console.log(todayQtyStr, this.cityName, '获取城市总运次')
            this.todayQtyStr1 = 0;
            this.todayQtyStr2 = 0;
            this.todayQtyStr3 = 0;
            this.todayQtyStr4 = 0;
            this.todayQtyStr5 = 0;
            this.todayQtyStr6 = 0;
            this.todayQtyStr7 = 0;
            this.todayQtyStr8 = 0;
            this.todayQtyStr1 = todayQtyStr.substring(0, 1);
            this.isTodayQtyStr1 = true
            if (todayQtyStr.length > 1) {
                this.isTodayQtyStr2 = true;
                this.todayQtyStr2 = todayQtyStr.substring(1, 2)
            } else { this.isTodayQtyStr2 = false }
            if (todayQtyStr.length > 2) {
                this.isTodayQtyStr3 = true;
                this.todayQtyStr3 = todayQtyStr.substring(2, 3);
            } else { this.isTodayQtyStr3 = false }
            if (todayQtyStr.length > 3) {
                this.isTodayQtyStr4 = true;
                this.todayQtyStr4 = todayQtyStr.substring(3, 4);
            } else { this.isTodayQtyStr4 = false }
            if (todayQtyStr.length > 4) {
                this.isTodayQtyStr5 = true;
                this.todayQtyStr5 = todayQtyStr.substring(4, 5);
            } else { this.isTodayQtyStr5 = false }
            if (todayQtyStr.length > 5) {
                this.isTodayQtyStr6 = true;
                this.todayQtyStr6 = todayQtyStr.substring(5, 6);
            } else { this.isTodayQtyStr6 = false }
            if (todayQtyStr.length > 6) {
                this.isTodayQtyStr7 = true;
                this.todayQtyStr7 = todayQtyStr.substring(6, 7);
            } else { this.isTodayQtyStr7 = false; }
            if (todayQtyStr.length > 7) {
                this.isTodayQtyStr8 = true;
                this.todayQtyStr8 = todayQtyStr.substring(7, 8);
            } else { this.isTodayQtyStr8 = false }
            if (todayQtyStr.length > 8) {
                this.isTodayQtyStr9 = true;
                this.todayQtyStr9 = todayQtyStr.substring(8, 9);
            } else { this.isTodayQtyStr9 = false }
        },
        // 获取城市今日运次数据处理
        jrcsycData(data) {
            var todayQty = 0;
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                todayQty += element.value
            }
            console.log(todayQty, this.cityName, '获取今日运次')
            todayQty = todayQty + "";
            this.todayQty1 = 0;
            this.todayQty2 = 0;
            this.todayQty3 = 0;
            this.todayQty4 = 0;
            this.todayQty5 = 0;
            this.todayQty1 = todayQty.substring(0, 1);
            this.isTodayQty1 = true;
            if (todayQty.length > 1) {
                this.isTodayQty2 = true;
                this.todayQty2 = todayQty.substring(1, 2)
            } else { this.isTodayQty2 = false; }
            if (todayQty.length > 2) {
                this.isTodayQty3 = true;
                this.todayQty3 = todayQty.substring(2, 3);
            } else { this.isTodayQty3 = false; }
            if (todayQty.length > 3) {
                this.isTodayQty4 = true;
                this.todayQty4 = todayQty.substring(3, 4);
            } else { this.isTodayQty4 = false; }
            if (todayQty.length > 4) {
                this.isTodayQty5 = true;
                this.todayQty5 = todayQty.substring(4, 5);
            } else { this.isTodayQty5 = false; }
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 530px;

    .content-div {
        width: 100%;
        height: 500px;
        padding: 10px 20px;
        overflow: hidden;

        .number {
            width: 100%;
            height: 80px;
            display: flex;
            font-family: 'Arial Normal', 'Arial', sans-serif;
            font-weight: 400;
            font-style: normal;
            color: rgba(255, 255, 255, 0.6549019607843137);
            text-align: left;
            margin-top: 20px;
            margin-bottom: 10px;
            position: absolute;
            bottom: 0;

            .number-div-1 {
                width: 70%;
                height: 100%;
            }

            .number-div-2 {
                height: 60px;
                font-family: 'DIN ', 'DIN', sans-serif;
                font-weight: 700;
                font-style: normal;
                font-size: 25px;
                color: #FFFFFF;
                display: flex;
                margin-top: 10px;

                div {
                    padding: 2px;
                    box-sizing: border-box;
                    width: 30px;
                    height: 38px;
                    box-sizing: border-box;
                    border: 1px solid rgba(89, 222, 255, 1);
                    border-radius: 5px;
                    margin: 3px;
                    text-align: center;
                    line-height: 34px;
                }

            }
        }
    }

    .content-div-2 {
        width: 100%;
        height: 390px;
    }
}
</style>